module.exports = __webpack_public_path__ + "static/media/BricolageGrotesque-Bold.2f7de7a3.ttf";